import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'

const PaymentFailed: FC = () => {
  return (
    <>
      <div className='d-flex flex-column flex-root'>
        <div className='d-flex flex-column flex-column-fluid '>
          <div className='d-flex flex-column flex-column-fluid text-center p-10 py-lg-20'>
            <div className='pt-lg-3 mb-5 mt-10'>
              <div className='vertical_center flex-column'>
                <div>
                  <img
                    src={toAbsoluteUrl('/media/logos/payment-failed.png')}
                    alt=''
                    className='h-100px mb-5'
                  />
                </div>
                <div>
                  <h1 className='fw-bolder fs-4x text-gray-700 mb-5'>Payment Failed</h1>
                  <div className='fw-bold fs-3 text-gray-400 mb-5'>
                    The Payment was unsuccessful due to an abnormality. <br /> Please try again or
                    later.
                  </div>
                </div>
              </div>
              <div className='text-center'>
                <Link to='/' className='btn btn-lg btn-primary fw-bolder text-uppercase'>
                  Go Back
                </Link>
              </div>
            </div>
          </div>

          <div className='d-flex flex-center flex-column-auto p-10'>
            <div className='d-flex align-items-center fw-bold fs-6'>
              <a href='https://keenthemes.com' className='text-muted text-hover-primary px-2'>
                About
              </a>
              <a
                href='mailto:support@keenthemes.com'
                className='text-muted text-hover-primary px-2'
              >
                Contact
              </a>
              <a
                href='https://1.envato.market/EA4JP'
                className='text-muted text-hover-primary px-2'
                target='_blank'
                rel='noreferrer'
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {PaymentFailed}
